import { ok } from "assert";
import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import Utils from "../../helper/utils";
import Contrato from "../classes/Contrato";
import Forecast from "../classes/Forecast";
import ForecastEstoqueConsumido from "../classes/ForecastEstoqueConsumido";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "Forecast/" },
  { method: "GET", rota: "Forecast/{id}" },
  { method: "POST", rota: "Forecast/Adicionar" },
  { method: "POST", rota: "Forecast/DetalharAno" },
  { method: "PUT", rota: "Forecast/Atualizar" },
  { method: "DELETE", rota: "Forecast/Apagar" },
  { method: "POST", rota: "Forecast/Diarizado/Montar" },
  { method: "POST", rota: "Forecast/Send" },
  { method: "POST", rota: "Forecast/ProcessarPlanilha/" },
  { method: "POST", rota: "Forecast/Atualizar/Colecao" },
  { method: "GET", rota: "Forecast/ObterPercentualConsumido" },
  { method: "GET", rota: "Forecast/RecuperarPorFiltro/" },
  { method: "POST", rota: "Forecast/Estorno" },
];

const cacheKey: string = "ForecastCache";
const cacheKeySelC: string = "ForecastSelecionado";

const apiServico: String = "PLANEJAMENTO";

interface integracao {
  idParceiro: Number;
  data: string;
  sku: string;
  centro: string;
  quantidade: number;
}

class ForecastDataset extends httpClient {
  constructor(apiServicoAlt: string = "") {
    if (apiServicoAlt === "") super(String(apiServico));
    else super(String(apiServicoAlt));
  }
  Adicionar(value: Forecast) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[2].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async RecuperarPorFiltros(filters: any, codigoFornecedorSap: number, passo: number): Promise<Forecast[]> {
    const baseURL = calls[11].rota + passo;
    // key = exampleKey -> ExampleKey
    // queryFilters result -> ExampleKey=123&OtherKey=321
    const queryFilters = Object.entries(filters).filter(([, value]) => !!value).map(([key, value]) => `${Utils.firstLetterToUpperCase(key)}=${value}`).join('&');
    const query = `?CodigoFornecedorSap=${codigoFornecedorSap}&${queryFilters}`;
    
    try {
      return super.Get(`${baseURL}${query}`).then(response => response.data);
    } catch (erro) {
      console.log(erro);
      return [];
    }
  }

  async DetalharAno(value: Contrato): Promise<Boolean> {
    return await super
      .post(calls[3].rota, value)
      .then((result) => {
        return result;
      })
      .catch((erro) => {
        console.log("DetalharAno - Erro: " + erro);
        return false;
      });
  }

  DetalharMes(value: Forecast) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[6].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  Atualizar(value: Forecast) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .put(calls[4].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  AtualizarColecao(value: Forecast[]): Promise<boolean> {
    return super
      .post(calls[9].rota, value)
      .then((result) => {
        return JSON.parse(result);
      })
      .catch((erro) => {
        return false;
      });
  }

  Apagar(value: Forecast) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .delete(calls[5].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async ListarAtivos(
    codigoFornecedorSap: number,
    numeroContrato: string
  ): Promise<Forecast[]> {
    return await super
      .Get(calls[0].rota + codigoFornecedorSap + "/Contrato/" + numeroContrato)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro);
      });
  }

  async ListarAtivosPorPasso(
    codigoFornecedorSap: number,
    numeroContrato: string,
    passo: number
  ): Promise<Forecast[]> {
    return await super
      .Get(
        calls[0].rota +
          codigoFornecedorSap +
          "/Contrato/" +
          numeroContrato +
          "/Passo/" +
          passo
      )
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro);
      });
  }

  async Integra(value: Forecast) {
    let dado: integracao = {
      idParceiro: value.codigoFornecedorSap,
      data: value.anoMesRef.toString(),
      sku: value.idSku.toString(),
      centro: value.centro.toString(),
      quantidade: value.quantidade,
    };
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[7].rota, dado)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async obterPercentualConsumido(forecastEstoqueConsumido: ForecastEstoqueConsumido): Promise<number> {
    let percentual: number;
    let ok: boolean = false;
    let error: any = undefined;
    let url: string = `${calls[10].rota}?CodigoFornecedorSap=${forecastEstoqueConsumido.codigoFornecedorSap}&NumeroContrato=${forecastEstoqueConsumido.numeroContrato}&CodigoSku=${forecastEstoqueConsumido.codigoSku}&Centro=${forecastEstoqueConsumido.centro}&MesAnoReferencia=${forecastEstoqueConsumido.mesAnoReferencia}`
    await super
      .Get(url)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        percentual = response.data;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<number>((resolve) => {
      resolve(percentual);
    });
  }

  async Estornar(value: Contrato) {
    try {
      const result = await super.post(calls[12].rota, value);
      return JSON.parse(result);
    } catch (erro) {
        console.log(erro);
        return false;
    }
  }

  getUrlUpload(): String {
    return calls[8].rota;
  }

  getKeyCache(): string {
    return cacheKey;
  }

  getKeyCacheClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): Forecast[] {
    let result: Forecast[] = JSON.parse(cacheKey);
    return result;
  }

  AdicionarListaAoCache(value: Forecast[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
export default ForecastDataset;
